import { Container, Grid } from '@mui/material'
import React from 'react'
import { P, SectionHeading, SectionSmallHeading, SectionSubHeading, SectionWrapper } from '../../Styles/style'

import telegram from "../../../assets/images/telegram.png"
import twitter from "../../../assets/images/twitter.png"
import styled from '@emotion/styled'

const AboutImage = styled.img`
  width: 100%;
  height: auto;
  /* max-width: 80%; */
`;
const VideoBK = styled.video`
  object-fit: cover;
  width: 100%;
  max-width: 100%;
  height: auto;
`; const GridHEading = styled(Grid)`
/* padding: 50px 0; */
align-items: center;
place-content: ${(props) => (props.pc ? props.pc : "")};
`;
const GridImage = styled(Grid)`
padding: 50px 0;
/* place-content: ${(props) => (props.pc ? props.pc : "center")};
text-align: center; */
text-align: left;
`;
const JOiningLinks = styled.img`
  /* width: 100%;
  max-width: ${(props) => (props.mw ? props.mw : "180PX")};
  @media screen and (max-width:599px){
   max-width: ${(props) => (props.mw ? props.mw : "140PX")};

 } */
`
const FeatureWrapper = styled.div`

height: 327px;
 background: 
    linear-gradient(#000000 0 0) padding-box, /*this is your grey background*/
    linear-gradient(319deg, #000,#000,#000, #1765FF) border-box;
  border: 1px solid transparent;
backdrop-filter: blur(13px) !important;
  padding: 20px;
`

const SectionSubHeadingSpan = styled.h3`
  font-family: "P-B";
  
  text-shadow:0px 0px 10px rgba(255, 255, 255, 0.223);
  background: ${(props) => (props.bgcolor ? props.bgcolor : "linear-gradient(1511deg,#FFDC00,#FFDC00, #FF00FF ,#FF00FF)")};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: ${(props) => (props.fs ? props.fs : "43px")};
  color: ${(props) => props.theme.textPrimary};
  padding: ${(props) => (props.p ? props.p : "20px 0")};
  margin: ${(props) => (props.m ? props.m : "0")};
  /* line-height: ${(props) => (props.lh ? props.lh : "50px")}; */
  max-width: ${(props) => (props.mw ? props.mw : "100%")};
  text-align: ${(props) => (props.align ? props.align : "left")};
  @media screen and (max-width: 1199px) {
    /* font-size: 30px; */
  }
  @media (max-width: 599px) {
    font-size: ${(props) => (props.fs599 ? props.fs599 : "")};
    padding: ${(props) => (props.p599 ? props.p599 : "")};
  }
  @media (max-width: 399px) {
    font-size: ${(props) => (props.fs399 ? props.fs399 : "40px")};
    padding: ${(props) => (props.p399 ? props.p399 : "")};
  }
`;
const CAdiv = styled.div`
display:flex;
justify-content:space-between;
background-color:#fff;
clip-path: polygon(2% 0, 98% 0, 100% 50%, 98% 100%, 2% 100%, 0% 50%);
  padding: 10px 30px;
  margin:20px 0 0 0;
`

const S7_Roadmap = () => {
    return (
        <div>
            <SectionWrapper p="12rem 0 0" p599="15rem 0 0" id="tokenomics">
                <Container maxWidth="xl">
                    <SectionHeading p="20px 0" m="0" fs="70px" align="center" data-aos="flip-up"
                        data-aos-easing="ease-in"
                        data-aos-delay="400"
                        data-aos-duration="500"
                        data-aos-offset="0">
                        Tokenomics
                    </SectionHeading>
                    <SectionSubHeadingSpan p="20px 0" m="0" fs="70px" align="center" data-aos="flip-up"
                        data-aos-easing="ease-in"
                        data-aos-delay="400"
                        data-aos-duration="500"
                        data-aos-offset="0">
                        BabyHEX
                    </SectionSubHeadingSpan>
                    <SectionSmallHeading align="center" p="0" fs="35px"  data-aos="flip-up"
                        data-aos-easing="ease-in"
                        data-aos-delay="400"
                        data-aos-duration="500"
                        data-aos-offset="0">Is A Memecoin With</SectionSmallHeading>
                    <SectionSmallHeading align="center" color="#FF00FF" fs="35px" p="0"  data-aos="flip-up"
                        data-aos-easing="ease-in"
                        data-aos-delay="400"
                        data-aos-duration="500"
                        data-aos-offset="0">10 Billion Total Supply
                    </SectionSmallHeading>
                    <SectionSmallHeading align="center" p="0" fs="35px"  data-aos="flip-up"
                        data-aos-easing="ease-in"
                        data-aos-delay="500"
                        data-aos-duration="500"
                        data-aos-offset="0">Built On
                    </SectionSmallHeading>
                    <SectionSubHeadingSpan p="20px 0" m="0" fs="70px" align="center" data-aos="flip-up"
                        data-aos-easing="ease-in"
                        data-aos-delay="500"
                        data-aos-duration="500"
                        data-aos-offset="0" bgcolor="linear-gradient(1511deg,#F8063A, #F8063A, #F8063A,#00D3FD,#00D3FD,#00D3FD)">
                        Pulsechain
                    </SectionSubHeadingSpan>
                    <SectionSmallHeading  data-aos="flip-up"
                        data-aos-easing="ease-in"
                        data-aos-delay="400"
                        data-aos-duration="500"
                        data-aos-offset="0" align="center" p="0" fs="35px">100% Of All Tokens
                    </SectionSmallHeading>
                    <SectionSmallHeading   data-aos="flip-up"
                        data-aos-easing="ease-in"
                        data-aos-delay="400"
                        data-aos-duration="500"
                        data-aos-offset="0" align="center" p="0" fs="35px">Are Distributed At Launch.
                    </SectionSmallHeading>


                    <GridHEading container spacing={3} justifyContent="center">
                        <GridImage item sm={12} lg={9} xl={8} data-aos="fade-up"
                            data-aos-anchor-placement="center-bottom" data-aos-delay="600"
                            data-aos-duration="500">

                            <CAdiv>
                                <SectionSmallHeading color="#000" align="center" p="0" >Contract:
                                </SectionSmallHeading>
                                <SectionSmallHeading  wb="break-all" color="#000" align="center" p="0" >0x2Dc74A935bBEBc793D79162736066Af829D2ba9A
                                </SectionSmallHeading>

                            </CAdiv>
                                <SectionSmallHeading align="center" p="20px 0" >Tax: 0/2
                                </SectionSmallHeading>
                        </GridImage>

                    </GridHEading>
                </Container>

            </SectionWrapper>
        </div>
    )
}

export default S7_Roadmap